import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, } from '@angular/material/dialog';
import { ModalConfig } from 'src/app/core/models/favoritesModals.model';


@Component({
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.css']
})
export class ModalsComponent {
  nameControl = new FormControl('', [Validators.required, Validators.maxLength(25)]);
  productName?:string = null;
  constructor(
    public dialogRef: MatDialogRef<ModalsComponent>,
    @Inject(MAT_DIALOG_DATA) public config: ModalConfig
  ) {
    if (config.action === 'rename') {
      this.nameControl.setValue(config.list.name);
    }
    if (config.action === 'delete-product') {
      this.productName = config.productName;
    }
  }

  onConfirm(): void {
    if (this.config.action === 'rename' && this.nameControl.valid) {
      this.dialogRef.close({ confirmed: true, newName: this.nameControl.value });
    } else if (this.config.action === 'delete') {
      this.dialogRef.close({ confirmed: true });
    } else if (this.config.action === 'delete-product') {
      this.dialogRef.close({ confirmed: true });
    }else if (this.config.action === 'new-list'){
      this.dialogRef.close({ confirmed: true, name: this.nameControl.value });
    }
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }
}
